/* eslint-disable functional/no-conditional-statement */
import { DynamicObject } from "../../address/hooks/useGetEmailFromToken";
import { setStyleProperties } from "./setStyleProperties";
import { SettingsState } from "./settingsAtom";

// For setting header position and related components
export function setHeaderPosition(settings: SettingsState) {
  const headerElement =
    document.querySelector<HTMLElement>("#mkhc-page-header");

  const toastElement = document.querySelector<HTMLElement>(".mkhc-toast-fixed");

  if (settings !== "initializing") {
    const isHeaderFixed = settings.styleOptions?.headerFixed;

    if (isHeaderFixed) {
      const headerStyle: DynamicObject = {
        position: "sticky",
        top: "0",
        "z-index": "10",
      };
      setStyleProperties(headerElement, headerStyle);

      const toastStyle: DynamicObject = {
        position: "fixed",
      };
      setStyleProperties(toastElement, toastStyle);
    }
  }
}
